module.exports = __webpack_public_path__ + "static/img/term_library_update.da8fdd80.gif";